module.exports = __webpack_public_path__ + "img/title.15551a4b.png";